/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteFacilityPhysician200ResponseData
 */
export interface DeleteFacilityPhysician200ResponseData {
    /**
     * 
     */
    id?: string;
}

/**
 * Check if a given object implements the DeleteFacilityPhysician200ResponseData interface.
 */
export function instanceOfDeleteFacilityPhysician200ResponseData(value: object): value is DeleteFacilityPhysician200ResponseData {
    return true;
}

export function DeleteFacilityPhysician200ResponseDataFromJSON(json: any): DeleteFacilityPhysician200ResponseData {
    return DeleteFacilityPhysician200ResponseDataFromJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityPhysician200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function DeleteFacilityPhysician200ResponseDataToJSON(json: any): DeleteFacilityPhysician200ResponseData {
    return DeleteFacilityPhysician200ResponseDataToJSONTyped(json, false);
}

export function DeleteFacilityPhysician200ResponseDataToJSONTyped(value?: DeleteFacilityPhysician200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

